import React, { useState, useEffect, useRef } from 'react';
import './SearchAndFilter.css';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { observer } from 'mobx-react-lite';
import attractionStore from '../../store/AttractionStore';
import languageStore from '../../store/languageStore';
import { useTranslation } from 'react-i18next';
import debounce from 'lodash.debounce';
import { useNavigate } from 'react-router-dom';

const SearchAndFilter = observer(({ setHeaderTitle, onFilterCategory }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownWidth, setDropdownWidth] = useState(0);
  const [title, setTitle] = useState("ALL ATTRACTIONS");
  const navigate = useNavigate();

  const debouncedSearch = debounce(async (value) => {
    if (value) {
      await attractionStore.fetchSearchResults(value);
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  }, 300);

  useEffect(()=>{
    const item = attractionStore.defaultCategories.find((item)=>item._id == selectedCategory);
    if(item?.content[languageStore?.selectedLanguage]?.title){
      setHeaderTitle(item.content[languageStore.selectedLanguage]?.title)
    }else{
      setHeaderTitle(t('ATTRACTIONS_all_attractions_title'))
    }
  },[languageStore.selectedLanguage])

  useEffect(() => {
    if (inputRef.current) {
      setDropdownWidth(inputRef.current.input.offsetWidth); 
    }
    debouncedSearch(query);
    return () => {
      debouncedSearch.cancel();
    };
  }, [query]);


  useEffect(() => {
    const handleResize = () => {
      if (inputRef.current) {
        setDropdownWidth(inputRef.current.input.offsetWidth);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

 
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.input.contains(event.target) 
      ) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  const handleSearchChange = (e) => {
    setQuery(e.target.value);
  };

  const handleCategoryClick = (category, name) => {
    setSelectedCategory(category);
    onFilterCategory(category, name);
    setHeaderTitle(name);
    setTitle(name);
  };

  const renderDropdown = () => {
    if (!showDropdown) return null;
    return (
      <div ref={dropdownRef} className="search-dropdown">
        {attractionStore.items.length > 0 ? (
          attractionStore.items.map((item, index) => {
            const language = languageStore.selectedLanguage;
            const title = item?.content?.[language]?.title || 'Untitled';
            return (
              <div 
                key={index} 
                onClick={() => {
                  setShowDropdown(false)
                  navigate('/under-construction')}}
              >
                  <div style={{ height: 1, backgroundColor: '#F9F9FB' }}></div>
                  <div className="search-item">
                    {title}
                  </div>
              </div>
            );
          })
        ) : (
          <div className="search-item">No results found</div>
        )}
      </div>
    );
  };

  return (
    <div className="background-part">
      <div className="background-content">
        <div className="search-container">
          <Input
            type="text"
            placeholder={t('SEARCH')}
            className={showDropdown ? "search-input-dropdown" : "search-input"}
            suffix={<SearchOutlined style={{ color: '#d3d3d3' }} />}
            value={query}
            onChange={handleSearchChange}
            ref={inputRef} 
          />
          {renderDropdown()}
        </div>
        <div className="button-group">
          <button
            className={`button ${selectedCategory === 'all' ? 'selected' : ''}`}
            onClick={() => handleCategoryClick('all', t('ATTRACTIONS_all_attractions_title'))}
          >
            {t('ATTRACTIONS_all_attractions_title')}
          </button>
          {attractionStore.defaultCategories.length > 0 &&
            attractionStore.defaultCategories.map((item) => (
              <button
                className={`button ${selectedCategory === item._id ? 'selected' : ''}`}
                key={item._id}
                onClick={() => handleCategoryClick(item._id, item.content[languageStore.selectedLanguage]?.title)}
              >
                {item.content[languageStore.selectedLanguage]?.title}
              </button>
            ))}
        </div>
        <hr style={{ width: '100%', borderColor: '#ef5106', border: '1px solid #ef5106' }} />
        <div className="button-group">
          <button
            className={`button ${selectedCategory === 'tours' ? 'selected' : ''}`}
            onClick={() => handleCategoryClick('tours')}
          >
            {t('ATTRACTIONS_sightseeing_tours_title')}
          </button>
          {attractionStore.tourCategories.length > 0 &&
            attractionStore.tourCategories.map((item) => (
              <button
                className={`button ${selectedCategory === item._id ? 'selected' : ''}`}
                key={item._id}
                onClick={() => handleCategoryClick(item._id)}
              >
                {item.content[languageStore.selectedLanguage]?.title}
              </button>
            ))}
        </div>
      </div>
    </div>
  );
});

export default SearchAndFilter;
